import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from "@mui/material";

import React from "react";
// components
import ReturnRow from "./ReturnRow";

const ReturnTable = ({ returnItems, exchangeItems }) => {
  const returnItemRows = returnItems.map(returnItem => (
    <ReturnRow item={returnItem} key={returnItem.id} />
  ));
  const exchangeItemRows = exchangeItems.map(exchangeItem => (
    <ReturnRow item={exchangeItem.orderitemPtr} key={exchangeItem.id} />
  ));

  const noItemsRow = (
    <TableRow>
      <TableCell colSpan={4} align="center">
        No items
      </TableCell>
    </TableRow>
  );
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell colSpan={4} className="bg-light">
              Returns
            </TableCell>
          </TableRow>
          {returnItemRows.length ? returnItemRows : noItemsRow}

          <TableRow>
            <TableCell colSpan={4} className="bg-light">
              Exchange
            </TableCell>
          </TableRow>
          {exchangeItemRows.length ? exchangeItemRows : noItemsRow}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReturnTable;
